"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapCartItemFromProduct = void 0;
const hasPromptDelivery = (tags) => tags.some((label) => label === 'Pronta-entrega');
const mapCartItemFromProduct = (product, businessUnit) => {
    var _a, _b, _c;
    return ({
        id: product.sku,
        brand: product.brand,
        category: product.category,
        cycle: product.cycle,
        discountPrice: product.salePrice.toString(),
        hasPromptDelivery: ((_a = product.tags) === null || _a === void 0 ? void 0 : _a.length) ? hasPromptDelivery(product.tags) : false,
        hasPromptDeliveryStock: product.availability.available,
        image: ((_b = product.images) === null || _b === void 0 ? void 0 : _b[0]) || '',
        businessUnit: businessUnit,
        name: product.name,
        price: product.price.toString(),
        tags: product.tags,
        quantity: product.quantity || 1,
        organizationName: (_c = product.organization) === null || _c === void 0 ? void 0 : _c.name,
    });
};
exports.mapCartItemFromProduct = mapCartItemFromProduct;
